export function categoryRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_CATEGORY_START":           
        case "TOGGLE_CATEGORY_ACTIVE_START":
        case "FETCH_CHILD_CATEGORIES_START":                                 
        case "FETCH_PARENT_CATEGORIES_START":                                 
        case "FETCH_PARENT_SPENT_START":                                 
        case "UPDATE_CATEGORY_START":                                 
        case "UPDATE_ACTIVE_BUDGET_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_CATEGORY_FULFILLED":           
        case "TOGGLE_CATEGORY_ACTIVE_FULFILLED":
        case "FETCH_CHILD_CATEGORIES_FULFILLED":                                 
        case "FETCH_PARENT_CATEGORIES_FULFILLED":                                 
        case "FETCH_PARENT_SPENT_FULFILLED":                                 
        case "UPDATE_CATEGORY_FULFILLED":                                 
        case "UPDATE_ACTIVE_BUDGET_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_CATEGORY_ERROR":
        case "TOGGLE_CATEGORY_ACTIVE_ERROR":
        case "FETCH_CHILD_CATEGORIES_ERROR":
        case "FETCH_PARENT_CATEGORIES_ERROR":
            case "FETCH_PARENT_SPENT_ERROR":
        case "UPDATE_CATEGORY_ERROR":
        case "UPDATE_ACTIVE_BUDGET_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}